import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrSC: CultureInfo = {
  name: 'fr-SC',
  displayName: 'français (Seychelles)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-SC',
  parent: CultureInfoFr
};
